<template>
  <div class="questionnaire-treeview-card">
    <QuestionnaireTransformDialog
      v-model="modals.questionnaireTransformDialog"
      @cancel="modals.questionnaireTransformDialog = false"
    />

    <TreeviewPanel
        :trees="trees"
        :filters="filters"
        :active-item.sync="activeItem"
    >
      <template v-slot:action-buttons>
          <AdButton
            type="add"
            :text="$t('transform-from-transaction')"
            :hint="$t('add-questionnaire-from-transaction')"
            list-item
            @click="modals.questionnaireTransformDialog = true"
          />
          <!-- <AdButton
            type="new"
            :hint="$t('new-questionnaire')"
            list-item
          /> -->
      </template>
    </TreeviewPanel>
  </div>
</template>

<script>
import TreeviewPanel from '@/components/Utilities/Treeview/TreeviewPanel'
import QuestionnaireTransformDialog from '@/components/Rule/QuestionnaireTransformDialog'

import { mapGetters } from 'vuex'

export default {
  name: 'QuestionnaireTreeViewCard',
  components: {
    TreeviewPanel,
    QuestionnaireTransformDialog
  },
  props: {
    trees: {
      type: [Array, Object],
      required: true
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      modals: {
        questionnaireTransformDialog: false
      }
    }
  },
  computed: {
    ...mapGetters('questionnaire', ['questionnaireActive']),

    activeItem: {
      get () {
        return this.questionnaireActive
      },
      set (val) {
        this.$store.commit('questionnaire/setQuestionnaireActive', val)
      }
    }
  }
}
</script>
